<template>
  <div v-if="show" class="success-popup-overlay" @click="$emit('close')">
    <div class="success-popup" @click.stop>
      <div class="success-popup-header">
        <div class="success-icon">{{ icon }}</div>
        <h3>{{ title }}</h3>
      </div>
      <div class="success-popup-body">
        <p>{{ message }}</p>
      </div>
      <div class="success-popup-actions">
        <button @click="$emit('close')" class="btn-success">Tamam</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSuccessPopup',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Başarılı' },
    message: { type: String, default: '' },
    icon: { type: String, default: '✅' }
  },
  emits: ['close']
}
</script>

<style scoped>
.success-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2500;
  animation: fadeIn 0.3s ease-out;
}

.success-popup {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  max-width: 450px;
  width: 90%;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.success-popup-header {
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.success-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.success-popup-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.success-popup-body {
  padding: 2rem;
  text-align: center;
}

.success-popup-body p {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
}

.success-popup-actions {
  padding: 1.5rem 2rem 2rem;
  text-align: center;
  border-top: 1px solid #eee;
}

.btn-success {
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  border: none;
  padding: 0.875rem 2.5rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(76, 175, 80, 0.4);
}

.btn-success:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .success-popup {
    max-width: 90%;
    margin: 1rem;
  }
  .success-popup-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  .success-icon {
    font-size: 3rem;
  }
  .success-popup-header h3 {
    font-size: 1.25rem;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
